const BASE_URL = process.env.REACT_APP_AUTH_URL;

export default {
    login: ({ username, password }) => {
        const request = new Request(BASE_URL , {
            method: 'POST',
            body: JSON.stringify({ email:username, password:password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then((fetched) => {
                //const decodedToken = decodeJwt(token);
                //localStorage.setItem('token', token);
                //localStorage.setItem('permissions', decodedToken.permissions);
                console.log(fetched);
                localStorage.setItem('username', fetched.user.email);
                localStorage.setItem('token', fetched.user.token);
            });
    },
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('permissions');
        return Promise.resolve();
    },
    checkError: error => {
        // console.log('err ', error)
        // throw error;
        return Promise.resolve();
    },
    checkAuth: () => {
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    },
    getPermissions: () => {
        //const role = localStorage.getItem('permissions');
        return Promise.resolve();
    }
};
